module.exports = __webpack_public_path__ + "img/gift.7bd75457.png";